"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var messages = {
    required: "This field is required",
    number: "This value only can be a number",
    string: "This value only can be string",
    email: "This value only can be email",
    minLength: "Min length is %1",
    pattern: "Error in pattern",
};
exports.default = messages;
//# sourceMappingURL=messages.js.map